exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-select-rank-table-list[data-v-1d1389ab]{width:100%;flex:1;overflow:hidden}.select-rank-tab-checkbox[data-v-1d1389ab]{display:flex}.select-rank-tab-checkbox .yxt-checkbox[data-v-1d1389ab]{margin-right:16px}.pc-biz-select-rank-tooptip[data-v-1d1389ab]{font-size:12px}.pc-biz-select-rank-tooptip p[data-v-1d1389ab]{margin:0}\n", ""]);

